"use client";

import React from "react";

export default function ExportCSV({ record, filenamePrefix = "invoice" }) {
  const q = (v) => {
    if (v === null || v === undefined) return '""';
    const s = typeof v === "object" ? JSON.stringify(v) : String(v);
    return `"${s.replace(/"/g, '""')}"`;
  };

  const toCSV = (rows, headers) => {
    if (!rows?.length) return "";
    const lines = [headers.join(",")];
    for (const r of rows) lines.push(headers.map((h) => q(r?.[h])).join(","));
    return lines.join("\n");
  };

  const download = (csv, name) => {
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = name;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  const summaryCols = [
    "Payment Status",
    "Invoice_Total",
    "ConsultantInvoice",
    "Status",
    "Name",
    "Title",
    "Company_Name",
    "Address",
    "City",
    "Zip",
    "Email",
    "Invoice_Date",
    "Phone",
    "EmailAddressAlt",
    "ProjectName",
    "State",
    "StartDate",
    "EndDate",
    "DueDate",
  ];

  const lineItemCols = [
    "quantity",
    "ProductType",
    "ProductDetail",
    "rate",
    "unit",
    "amount",
  ];

  const locationCols = ["city", "state"];

  const summaryRow = {};
  summaryCols.forEach((k) => (summaryRow[k] = record?.[k]));

  const lineItems = Array.isArray(record?.lineItems)
    ? record.lineItems.map((li) => {
        const o = {};
        lineItemCols.forEach((k) => (o[k] = li?.[k]));
        return o;
      })
    : [];

  const locations = Array.isArray(record?.locations)
    ? record.locations.map((loc) => {
        const o = {};
        locationCols.forEach((k) => (o[k] = loc?.[k]));
        return o;
      })
    : [];

  const handleExport = () => {
    // Merge top-level + line items into one CSV for convenience
    const merged = lineItems.length
      ? lineItems.map((li) => ({ ...summaryRow, ...li }))
      : [summaryRow];
    const headers = [...summaryCols, ...lineItemCols];
    const csv = toCSV(merged, headers);
    download(csv, `${filenamePrefix}.csv`);
  };

  return (
    <span onClick={handleExport} style={{ cursor: "pointer" }}>
      Export CSV
    </span>
  );
}
